
import { Link } from "react-router-dom";
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireinpune() {



    const cardData =
    {
        keyword: 'Bus Hire in Pune  ',
        heading: 'Amruta Travels: Bus Hire in Pune',
        headingDescription: 'Amruta Travels offers Bus Hire in Pune, delivering reliable and comfortable transportation solutions for all your travel needs. Whether it’s a wedding, corporate event, school excursion, or a weekend getaway, we provide a wide range of well-maintained buses, including 25-seater, 35-seater, 40-seater, and 50-seater options to match your group size. With professional drivers, timely service, and competitive pricing, Amruta Travels ensures a smooth and enjoyable journey every time. Experience hassle-free bus rental services in Pune with easy booking, 24/7 support, and a commitment to passenger safety and satisfaction. Choose Amruta Travels for your next group trip in Pune!',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


  "services": [
    {
   name:"Bus Hire in Pune",
   link:"/Bus-Hire-in-Pune",
      "description": "Amruta Travels offers reliable bus hire services in Pune for all your travel needs. Whether it's a local event, family function, or corporate outing, we've got the right bus for you."
    },
    {
 name:"Bus On Rent Pune",
 link:"/Bus-On-Rent-in-Pune",
      "description": "Rent a bus in Pune with ease through Amruta Travels. We provide a wide range of buses suitable for events, tours, school outings, and more."
    }, 
    {
 name:"Mini Bus On Rent Pune",
 link:"/Mini-Bus-On-Rent-Pune",
      "description": "Amruta Travels offers mini buses on rent in Pune, perfect for smaller groups, city travel, and short-distance tours with comfortable seating and air-conditioning."
    },
    {
      "name": "32 Seater Bus on Rent in Pune",
      link:"/32-Seater-Bus-on-Rent-in-Pune",
      "description": "Hire a 32-seater bus in Pune from Amruta Travels for mid-sized group travel. Ideal for office trips, weddings, and excursions with AC and pushback seats."
    },
    {
      "name": "17 Seater Bus on Rent in Pune",
      link:"/17-Seater-Bus-on-Rent-in-Pune",
      "description": "Looking for compact group travel? Rent a 17-seater bus in Pune from Amruta Travels for family trips, local tours, or staff transportation."
    },
    {
      "name": "25 Seater Bus Hire in Pune",
      link:"/25-Seater-Bus-Hire-in-Pune",
      "description": "Amruta Travels provides 25-seater bus hire in Pune, suitable for school outings, social functions, and office events with comfortable interiors."
    },
    {
      "name": "25 Seater Bus On Rent in Pune",
      link:"/25-Seater-Bus-On-Rent-in-Pune",
      "description": "Book a 25-seater bus on rent in Pune through Amruta Travels for group travel with AC comfort, experienced drivers, and affordable pricing."
    },
    {
      "name": "32 Seater Bus Rent in Pune",
      link:"/32-Seater-Bus-Rent-in-Pune",
      "description": "Amruta Travels offers 32-seater buses for rent in Pune, perfect for both short and long-distance travel with pushback seats and smooth service."
    },
    {
      "name": "35 Seater Bus on Rent in Pune",
      link:"/35-Seater-Bus-on-Rent-in-Pune",
      "description": "Hire a 35-seater bus in Pune from Amruta Travels for weddings, corporate outings, and religious trips. Spacious and air-conditioned for comfort."
    },
    {
      "name": "45 Seater Bus on Rent in Pune",
      link:"/45-Seater-Bus-on-Rent-in-Pune",
      "description": "Travel in groups with Amruta Travels’ 45-seater bus rentals in Pune. Ideal for company events, school trips, or large family functions."
    },
    {
      "name": "40 Seater Bus on Rent in Pune",
      link:"/40-Seater-Bus-on-Rent-in-Pune",
      "description": "Book a 40-seater bus with Amruta Travels in Pune for events, tours, and transfers. Equipped with AC and ample legroom for a pleasant journey."
    },
    {
      "name": "50 Seater Bus on Rent in Pune",
      link:"/50-Seater-Bus-on-Rent-in-Pune",
      "description": "Rent a 50-seater bus in Pune with Amruta Travels for large group transportation needs. Our buses are spacious, reliable, and perfect for long trips."
    },
    {
      "name": "Mini Bus Hire in Pune",
      link:"/Mini-Bus-Hire-in-Pune",
      "description": "Amruta Travels offers mini bus hire in Pune with online booking, AC options, and professional drivers. Great for short journeys or small groups."
    },
    {
      "name": "Rent a Bus Pune",
      link:"/Rent-a-Bus-Pune",
      "description": "Looking to rent a bus in Pune? Amruta Travels provides a full range of rental options, from mini to large-capacity buses for every occasion."
    },
    {
      "name": "Mini Bus Rental Pune",
      link:"/Mini-Bus-Rental-Pune",
      "description": "Amruta Travels specializes in mini bus rental in Pune for small events, office use, or family outings with high-quality, clean vehicles."
    },
    {
      "name": "Volvo Bus on Rent in Pune",
      link:"/Volvo-Bus-on-Rent-in-Pune",
      "description": "Book a luxury Volvo bus on rent in Pune with Amruta Travels. Ideal for long-distance comfort, AC interiors, and smooth travel for large groups."
    },
    {
      "name": "Private Bus Hire in Pune",
      link:"/Private-Bus-Hire-in-Pune",
      "description": "Hire a private bus in Pune with Amruta Travels for weddings, group tours, or executive transport. Our private buses ensure comfort and privacy."
    },
    {
      "name": "Bus Hire in Pune for Family",
      link:"/Bus-Hire-in-Pune-for-Family",
      "description": "Travel with your family in comfort with Amruta Travels’ family bus hire service in Pune. Perfect for picnics, weddings, or outstation trips."
    },
    {
      "name": "Bus Hire in Pimpri Chinchwad",
      link:"/Bus-Hire-in-Pimpri-Chinchwad",
      "description": "Amruta Travels provides bus hire services in Pimpri Chinchwad for local and intercity travel. Choose from mini to full-size buses with easy booking."
    },
    {
      "name": "Bus Hire in Katraj Pune",
      link:"/Bus-Hire-in-Katraj-Pune",
      "description": "Looking for a bus in Katraj? Amruta Travels offers quality bus hire services with AC options and experienced drivers for any travel requirement."
    },
    {
      "name": "Bus Hire in Kothrud Pune",
      link:"/Bus-Hire-in-Kothrud-Pune",
      "description": "Hire buses in Kothrud, Pune with Amruta Travels. Suitable for events, pilgrimages, or company outings with timely and professional service."
    },
    {
      "name": "Bus Hire in Nagar Pune",
      link:"/Bus-Hire-in-Nagar-Pune",
      "description": "Book bus rentals from Nagar Road, Pune through Amruta Travels. We provide efficient transportation for groups of all sizes and purposes."
    },
    {
      "name": "Bus Hire in Dhayari Pune",
      link:"/Bus-Hire-in-Dhayari-Pune",
      "description": "Amruta Travels offers bus hire services in Dhayari, Pune. Whether for school trips or private events, our fleet ensures a safe and smooth ride."
    }
    ,
{
   name: "Bus Rental in Pune",
   link: "/bus-rental-in-pune",
   description: "Book luxury bus rental in Pune for weddings, corporate events, school trips, family tours and outstation travel with Amruta Travels."
}
  ],
  "tableData": [
    ["Bus Hire in Pune", "Bus on Rent Pune"],
    ["Mini Bus On Rent Pune", "32 Seater Bus on Rent in Pune"],
    ["17 Seater Bus on Rent in Pune", "25 Seater Bus Hire in Pune"],
    ["25 Seater Bus On Rent in Pune", "32 Seater Bus Rent in Pune"],
    ["35 Seater Bus on Rent in Pune", "45 Seater Bus on Rent in Pune"],
    ["40 Seater Bus on Rent in Pune", "50 Seater Bus on Rent in Pune"],
    ["Mini Bus Hire in Pune", "Rent a Bus Pune"],
    ["Mini Bus Rental Pune", "Volvo Bus on Rent in Pune"],
    ["Private Bus Hire in Pune", "Bus Hire in Pune for Family"],
    ["Bus Hire in Pimpri Chinchwad", "Bus Hire in Katraj Pune"],
    ["Bus Hire in Kothrud Pune", "Bus Hire in Nagar Pune"],
    ["Bus Hire in Dhayari Pune", ""]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Convenient Bus Hire in Pune for All Occasions",
    "WhyChoosedescription": "Amruta Travels offers reliable and convenient bus hire services in Pune for any occasion. Whether you need a bus for corporate travel, family outings, weddings, or group trips, we have a fleet of modern buses to suit your needs. Our buses provide comfort, luxury, and reliability, ensuring you have a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Buses for Every Need",
    "WhyChoosedescription": "Our fleet of buses includes a wide range of options, from small minibuses to large luxury coaches, designed to accommodate groups of all sizes. With spacious seating, plush interiors, and modern amenities, our buses offer superior comfort for both short and long-distance travel within Pune and beyond."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Bus Hire",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for bus hire services in Pune. We ensure that our prices are affordable without compromising on quality. Our all-inclusive pricing covers fuel, tolls, driver allowances, and taxes, so you can plan your budget confidently without worrying about hidden costs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our buses are driven by highly trained and experienced drivers who prioritize safety, punctuality, and passenger comfort. Whether you're traveling locally in Pune or embarking on a long-distance journey, our drivers ensure a smooth and secure travel experience for all passengers."
  },
  {
    "WhyChooseheading": "Tailored Bus Hire Solutions for Corporate and Group Travel",
    "WhyChoosedescription": "For corporate events, group tours, or large family gatherings, Amruta Travels provides tailored bus hire solutions. We understand the unique requirements of group travel, ensuring your trip is seamless and stress-free. Our buses come equipped with modern amenities like air conditioning, entertainment systems, and ample luggage space for your comfort."
  },
  {
    "WhyChooseheading": "Reliable and Timely Bus Services in Pune",
    "WhyChoosedescription": "We value your time and ensure that our bus hire services are punctual and reliable. When you book with Amruta Travels, you can trust that your bus will arrive on time and take you to your destination efficiently. Our timely service ensures you stay on schedule for all your important events and trips."
  },
  {
    "WhyChooseheading": "Easy Booking Process for Hassle-Free Experience",
    "WhyChoosedescription": "Booking a bus with Amruta Travels is simple and hassle-free. You can book your bus hire online or by phone, and our team will assist you in choosing the best vehicle for your needs. Our straightforward booking process ensures that your travel arrangements are made quickly and easily, so you can focus on enjoying your journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for All Your Queries",
    "WhyChoosedescription": "Amruta Travels offers round-the-clock customer support to assist you with any questions or concerns regarding your bus hire in Pune. Our friendly support team is available at any time to help with bookings, itineraries, or any other requests, ensuring a smooth and satisfactory travel experience."
  }
]


















    }

const faqData = [
  {
    question: 'Can I hire a bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers bus hire services in Pune. We provide a fleet of Bharatbenz buses that are ideal for both local and outstation trips, ensuring comfort and reliability for your journey.',
  },
  {
    question: 'What types of buses can I hire in Pune?',
    answer: 'Amruta Travels offers Bharatbenz buses with various seating capacities, including 32, 35, 40, and 50 seats. You can hire the bus that best suits your group size and travel needs.',
  },
  {
    question: 'Can I hire a bus for both local and outstation trips in Pune?',
    answer: 'Yes, Amruta Travels offers bus hire services for both local travel within Pune and outstation trips to destinations like Shirdi, Mahabaleshwar, Lonavala, Goa, and more.',
  },
  {
    question: 'Do I need to provide my own driver when hiring a bus?',
    answer: 'No, all our bus hire services include an experienced and licensed driver who will ensure the safety, comfort, and smooth operation of your trip.',
  },
  {
    question: 'How much does it cost to hire a bus in Pune?',
    answer: 'The cost of hiring a bus depends on various factors such as bus type, trip duration, distance, and services required. Please reach out to us with your travel details for a customized quote.',
  },
  {
    question: 'Can I hire a bus for corporate or private events in Pune?',
    answer: 'Absolutely! Amruta Travels offers bus hire services for corporate events, family gatherings, weddings, and group tours. Our buses are designed to provide luxury, comfort, and punctuality for your special events.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, all our buses are thoroughly maintained and sanitized before every trip to ensure the highest standards of safety, hygiene, and comfort for all passengers.',
  },
  {
    question: 'Why should I choose Amruta Travels for bus hire in Pune?',
    answer: 'Amruta Travels is known for its professional and reliable service. Our Bharatbenz buses are top-of-the-line vehicles that provide a smooth and comfortable travel experience, whether you are traveling locally or on an outstation trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vinay Deshmukh',
    role: 'Business Owner, Pune',
    text: 'We hired a Bharatbenz bus from Amruta Travels for a corporate trip. The bus was clean, well-maintained, and provided a smooth and comfortable ride. The driver was professional and made sure everything went smoothly. Highly recommend!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Shweta Iyer',
    role: 'Event Organizer',
    text: 'I hired a bus from Amruta Travels for a wedding event. The bus was spacious, on time, and comfortable. The entire experience was seamless, from booking to the trip. Excellent service and highly recommended!',
    rating: 5,
  },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Luxury Bus Rental in Pune" },
        { src: "/images/gallery/28.jpg", alt: "40 Seater Bus on Rent in Pune" },
        { src: "/images/gallery/2.jpg", alt: "Corporate Bus Hire in Pune" },
        { src: "/images/gallery/3.jpg", alt: "Bus Hire for Wedding in Pune" },
        { src: "/images/gallery/24.jpg", alt: "Bus Hire in Pune" },
        { src: "/images/gallery/27.jpg", alt: "50 Seater Bus on Rent in Pune" },
        { src: "/images/gallery/29.jpg", alt: "Mini Bus Hire in Pune" },
        { src: "/images/gallery/30.jpg", alt: "Volvo Bus on Rent in Pune" },
        { src: "/images/gallery/31.jpg", alt: "Outstation Bus Hire from Pune" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pune",
  "image": "https://bushireinpune.com/images/keyword/68.jpg",
  "description": "Amruta Travels offers bus hire services in Pune with options ranging from mini buses to 50-seater buses. We provide buses on rent for family trips, corporate events, weddings, picnics, and more. Choose from 17-seater, 25-seater, 32-seater, 40-seater, 45-seater, and 50-seater buses. Get reliable and affordable bus rental services for all your transportation needs.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "15400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",  
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-in-pune",
"mainEntityOfPage": {
  "@type": "WebPage",
  "@id": "https://bushireinpune.com/bus-hire-in-pune"
}
  }
};

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",

  "serviceType": "Bus Hire in Pune",

  "name": "Bus Hire in Pune",

  "description":
    "Amruta Travels provides bus hire services in Pune for weddings, corporate events, school trips, airport transfers, family outings and outstation travel.",

  "provider": {
  "@type": "LocalBusiness",
  "name": "Amruta Travels",
  "url": "https://bushireinpune.com",
  "telephone": "+91 7353109555"
},

  "areaServed": {
  "@type": "AdministrativeArea",
  "name": "Pune, Maharashtra"
},

  "url": "https://bushireinpune.com/bus-hire-in-pune"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://bushireinpune.com"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Bus Hire in Pune",
      "item": "https://bushireinpune.com/bus-hire-in-pune"
    }
  ]
};
    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Bus Hire in Pune | Amruta Travels</title>
  <meta 
    name="description" 
    content="Bus Hire in Pune for family trips, corporate events, weddings, picnics & more. Choose from 17-seater, 25-seater, 32-seater, 50-seater & Volvo buses. Affordable & reliable bus hire service by Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>

  <script type="application/ld+json">
    {JSON.stringify(breadcrumbSchema)}
</script>
</Helmet>

{/* <Helmet>
  <title>Call: +91 7353109555 | Bus Hire in Pune | Mini & Luxury Bus Rental Services | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a bus in Pune for family trips, corporate events, weddings, picnics & more. Choose from 17-seater, 25-seater, 32-seater, 50-seater & Volvo buses. Affordable & reliable bus hire service by Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h1 className="white text-center">
Bus Hire in Pune
</h1>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><div className="mt-4">

<h2>Best Bus Hire in Pune for Local & Outstation Travel</h2>

<p>
Looking for reliable Bus Hire in Pune? Amruta Travels offers safe, comfortable, and affordable bus rental services for every travel requirement. Whether you need transportation for a wedding, corporate event, school trip, family function, airport transfer, picnic, or outstation tour, we provide a wide range of well-maintained buses with professional drivers.
</p>

<p>
Our fleet includes 17 Seater, 25 Seater, 32 Seater, 35 Seater, 40 Seater, 45 Seater and 50 Seater buses along with luxury Bharat Benz buses, Volvo buses, mini buses and Force Urbania vehicles. Every vehicle is regularly maintained to ensure passenger safety and comfort throughout the journey.
</p>

<h2>Why Thousands of Customers Choose Amruta Travels</h2>

<p>
With years of experience in group transportation, Amruta Travels has become one of the trusted names for Bus Hire in Pune. We focus on punctual service, transparent pricing, experienced drivers, clean vehicles and quick customer support. Our team understands the transportation requirements of corporate companies, educational institutions, wedding planners, tour operators and families.
</p>

<p>
From short city rides to long-distance journeys across Maharashtra and India, we offer customized transportation solutions at competitive prices. Whether your group has 10 passengers or 50 passengers, we have the perfect vehicle for your trip.
</p>

</div>
                            
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">
    <Link
        to={service.link}
        className="text-decoration-none darkcolorrr"
    >
        {service.name}
    </Link>
</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img
    src={e.place}
    alt={e.text}
    loading="lazy"
/>
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
    src={image.src}
    alt={image.alt}
    className="gallery-image"
    loading="lazy"
/>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireinpune;